module.exports = __webpack_public_path__ + "static/img/draw_area.a54562f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/826/draw_area.png
// module id = 501
// module chunks = 1